import { DefaultService } from '@/services/DefaultService';

/* @71147 - Cadastro de cultura- Aba produto */
export default class AssTipoCulturaProdutoService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

      findAll(column, order, page, limit, situacao, idtipocultura, contexto = "agro", ...params) {
        return this._http.get(encodeURI(`${this._env}/${contexto}/${contexto}-cultura/asstipoculturaproduto.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idtipocultura=${idtipocultura}&param=${params}`), this._headers).then(res => {
          return res.body;
        }, err => {
          this.verifyError(err);
          throw new Error('Problems while jobs are loading');
        });
      }
      updateSituacao(asstipoculturaproduto, contexto = "agro") {
        return this._http.post(`${this._env}/${contexto}/${contexto}-cultura/asstipoculturaproduto/updatesituacao`, asstipoculturaproduto, this._headers).then(res => {
          return res.body;
        }, err => {
          this.verifyError(err);
          throw err;
        });
      }
      listCulturasNaoAssByProduct (idproduto, column, order = 'asc', page = 0, limit = 50, ...param) {
        return this._http.get(`${this._env}/ven/produto/naoassprodutotipocultura.json?idproduto=${idproduto}&page=${page}&limit=${limit}&order=${order}&column=${column}&param=${param}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
      } 
      listCulturasByProduct (idproduto, column, page = 0, limit = 50, order = 'asc', ...param) {
        return this._http.get(`${this._env}/ven/produto/assprodutotipocultura.json?idproduto=${idproduto}&page=${page}&limit=${limit}&order=${order}&column=${column}&param=${param}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
      }

      findNaoAssociados(column, order, page, limit, idtipocultura, contexto = "agro", ...params) {
        return this._http.get(encodeURI(`${this._env}/${contexto}/${contexto}-cultura/asstipoculturaproduto/naoassociados?page=${page}&limit=${limit}&column=${column}&order=${order}&idtipocultura=${idtipocultura}&param=${params}`), this._headers).then(res => {
          return res.body;
        }, err => {
          this.verifyError(err);
          throw err;
        });
      }
      save(lista, contexto = "agro") {
        return this._http.post(`${this._env}/${contexto}/${contexto}-cultura/asstipoculturaproduto`, lista, this._headers).then(res => {
          return res.body;
        }, err => {
          this.verifyError(err);
          throw err;
        });
      }
}